import { createRoot } from 'react-dom/client';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router';
import MyProvider from './context/provider';
import { Toaster } from 'components/ui/toaster';
import './globals.css';
import { TooltipProvider } from 'components/ui/tooltip';

// Datadog Browser SDK initialization (RUM + Logs + PII masking + request correlation).
// Imported for side-effects only — the module self-initializes on import.
// Must be imported before rendering to capture all browser activity.
import './lib/datadog';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <SnackbarProvider
    dense
    hideIconVariant
    maxSnack={1}
    autoHideDuration={5000}
    action={(snackbarId) => (
      <IconButton onClick={() => closeSnackbar(snackbarId)} size="small">
        <Close />
      </IconButton>
    )}>
    <TooltipProvider>
      <Router>
        <MyProvider>
          <App />
          <Toaster />
        </MyProvider>
      </Router>
    </TooltipProvider>
  </SnackbarProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
